import { ReceiptAlertTypeFilter } from '@synergy/components';

import { PaloFilterPanel } from '../../../common/components/palo/palo-filter-panel';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';
import { CustomerFilter } from '../../../common/components/filter/customer-filter';
import { ResponsibleContactFilter } from '../../../common/components/filter/responsible-contact-filter';

/**
 * PALO filter for this list.
 *
 * The rows above come from the list itself and cover every field it declared,
 * each with its own comparison. What stays here are the ones that look a
 * record up by name and hand over its id, which no generic control can do.
 *
 * Gone with the rows: the date range, which the declared `createdAt` now
 * offers with `ab`, `bis` and `zwischen` — offering the same filter twice is
 * what made the toolbar confusing before (#2184). The status filter stays out
 * as well: the sub-views of the navigation set it, and correctly (#2144).
 */
export const PaloDemandOverviewFilter = () => {
    return (
        <PaloFilterPanel listKey="demands">
            <ResponsibleContactFilter />
            <CustomerFilter />
            <CustomerContactFilter />
            <ReceiptAlertTypeFilter />
        </PaloFilterPanel>
    );
};
